import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import { Icon, Tooltip, testClass } from 'omni-common-ui';

const CardActionIcons = (props) => {
  const {
    hideEditIcon,
    hideDeleteIcon,
    className,
    onEditClick,
    onDeleteClick,
    editHref,
    deleteHref,
  } = props;
  return <div className={classnames(styles.CardActionIcons, className)}>
    {
      ! hideEditIcon &&
      <Tooltip className={styles.CardActionIcons_item}
          text="Edit"
          placement="top"
          trigger={['hover']}>
        <Link to={editHref}
            onClick={onEditClick}
            role="button"
            tabIndex="0">
          <Icon className={testClass('edit-icon')} id="edit" />
        </Link>
      </Tooltip>
    }
    {
      ! hideDeleteIcon &&
      <Tooltip className={styles.CardActionIcons_item}
          text="Delete"
          placement="top"
          trigger={['hover']}>
        <Link to={deleteHref}
            onClick={onDeleteClick}
            role="button"
            tabIndex="0">
          <Icon id="trash" />
        </Link>
      </Tooltip>
    }
  </div>;
};

CardActionIcons.propTypes = {
  editHref: PropTypes.string,
  deleteHref: PropTypes.string,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  hideEditIcon: PropTypes.bool,
  hideDeleteIcon: PropTypes.bool,
  className: PropTypes.string,
};

export default CardActionIcons;



// WEBPACK FOOTER //
// ./components/CardActionIcons/index.jsx